import React from 'react'
import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/officialmd/MD-Portfolio'
      className='link footer__link'
    >
      Created By Mohamad Deifallah
    </a>
  </footer>
)

export default Footer
